(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ddu-air-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ddu-hero-carousel')) {
    customElements.define(
      'ddu-hero-carousel',
      class DduHeroCarousel extends HTMLElement {
        connectedCallback() {
          this.slides = Array.from(this.querySelectorAll('[data-ddu-hero-slide]'));
          this.dots = Array.from(this.querySelectorAll('[data-ddu-hero-dot]'));
          this.previousButton = this.querySelector('[data-ddu-hero-previous]');
          this.nextButton = this.querySelector('[data-ddu-hero-next]');
          this.pauseButton = this.querySelector('[data-ddu-hero-pause]');
          this.index = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));
          this.autoplayEnabled = this.dataset.autoplay === 'true';
          this.interval = Math.max(3000, Number(this.dataset.interval) || 6500);
          this.isPaused = false;
          this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
          this.abortController?.abort();
          this.abortController = new AbortController();
          const { signal } = this.abortController;

          this.previousButton?.addEventListener('click', () => this.goTo(this.index - 1, true), { signal });
          this.nextButton?.addEventListener('click', () => this.goTo(this.index + 1, true), { signal });
          this.dots.forEach((dot) => {
            dot.addEventListener('click', () => this.goTo(Number(dot.dataset.slideIndex), true), { signal });
          });
          this.pauseButton?.addEventListener('click', () => this.togglePause(), { signal });
          if (window.matchMedia('(hover: hover)').matches) {
            this.addEventListener('mouseenter', () => this.stopTimer(), { signal });
            this.addEventListener('mouseleave', () => this.startTimer(), { signal });
          }
          this.addEventListener('focusin', () => this.stopTimer(), { signal });
          this.addEventListener('focusout', (event) => {
            if (!this.contains(event.relatedTarget)) this.startTimer();
          }, { signal });
          document.addEventListener('visibilitychange', () => {
            if (document.hidden) this.stopTimer();
            else this.startTimer();
          }, { signal });

          this.observer?.disconnect();
          this.observer = new IntersectionObserver(
            ([entry]) => {
              this.isVisible = entry.isIntersecting;
              if (this.isVisible) this.startTimer();
              else this.stopTimer();
            },
            { threshold: 0.2 }
          );
          this.observer.observe(this);
          this.goTo(this.index, false);
        }

        disconnectedCallback() {
          this.stopTimer();
          this.observer?.disconnect();
          this.abortController?.abort();
        }

        goTo(nextIndex, userInitiated = false) {
          if (this.slides.length < 1) return;
          this.index = (nextIndex + this.slides.length) % this.slides.length;
          this.slides.forEach((slide, slideIndex) => {
            const active = slideIndex === this.index;
            slide.classList.toggle('is-active', active);
            slide.setAttribute('aria-hidden', String(!active));
            slide.querySelectorAll('a, button, input, select, textarea').forEach((control) => {
              if (active) control.removeAttribute('tabindex');
              else control.setAttribute('tabindex', '-1');
            });
          });
          this.dots.forEach((dot, dotIndex) => {
            const active = dotIndex === this.index;
            dot.classList.toggle('is-active', active);
            dot.setAttribute('aria-selected', String(active));
          });
          if (userInitiated) {
            this.stopTimer();
            this.startTimer();
          }
        }

        startTimer() {
          this.stopTimer();
          if (
            !this.autoplayEnabled ||
            this.isPaused ||
            this.reducedMotion.matches ||
            this.slides.length < 2 ||
            this.isVisible === false ||
            document.hidden
          ) return;
          this.timer = window.setInterval(() => this.goTo(this.index + 1), this.interval);
        }

        stopTimer() {
          if (this.timer) window.clearInterval(this.timer);
          this.timer = null;
        }

        togglePause() {
          this.isPaused = !this.isPaused;
          this.pauseButton.setAttribute('aria-pressed', String(this.isPaused));
          const label = this.isPaused ? this.pauseButton.dataset.playLabel : this.pauseButton.dataset.pauseLabel;
          this.pauseButton.setAttribute('aria-label', label);
          const icon = this.pauseButton.querySelector('[data-ddu-hero-pause-icon]');
          if (icon) icon.textContent = this.isPaused ? '▶' : 'Ⅱ';
          if (this.isPaused) this.stopTimer();
          else this.startTimer();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
